export default __webpack_public_path__ + "apply132de42a.png";